export default __webpack_public_path__ + "static/media/mission-img-2.1d55ff6e.webp";